<form [formGroup]="form"
      (ngSubmit)="onSubmit($event)">
  <div class="fields">
    <mat-form-field>
      <mat-label>Текст</mat-label>
      <input matInput
             formControlName="search"
             type="text"
             autocomplete="off"
             [autofocus]="['autofocus']">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Завершён</mat-label>
      <mat-select formControlName="isFinished">
        <mat-option>Любой</mat-option>
        <mat-option value="true">Завершён</mat-option>
        <mat-option value="false">Не завершён</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Проверен</mat-label>
      <mat-select formControlName="isChecked">
        <mat-option>Любой</mat-option>
        <mat-option value="true">Проверен</mat-option>
        <mat-option value="false">Не проверен</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="buttons">
    <button mat-flat-button
            color="primary"
            type="submit"
            (click)="onSubmit($event)">Применить
    </button>
    <button mat-flat-button
            type="button"
            (click)="onClear($event)">Очистить
    </button>
  </div>
</form>
